import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/auth-context";
import { sendVerificationEmail } from "@/services/auth";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const EmailVerificationBlocker = () => {
  const { user } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [countdown, setCountdown] = useState(0);

  // Handle resend verification email
  const handleResendVerification = async () => {
    if (isResending || countdown > 0 || !user?.email) return;

    try {
      setIsResending(true);
      await sendVerificationEmail(user.email);
      toast.success("Verification email sent successfully!");
      // Start a 60-second countdown to prevent spam
      setCountdown(60);
    } catch (error) {
      console.error("Failed to resend verification email:", error);
      toast.error(
        "Failed to resend verification email. Please try again later."
      );
    } finally {
      setIsResending(false);
    }
  };

  // Countdown timer for resend button
  useEffect(() => {
    if (countdown <= 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center mb-4">
          Email Verification Required
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          Please verify your email address ({user?.email || ""}) to continue
          using the application. Check your inbox for a verification email.
        </p>
        <div className="flex justify-center">
          <Button
            onClick={handleResendVerification}
            disabled={isResending || countdown > 0}
            className="w-full"
          >
            {countdown > 0
              ? `Resend in ${countdown}s`
              : isResending
              ? "Sending..."
              : "Resend Verification Email"}
          </Button>
        </div>
      </div>
    </div>
  );
};
